import React from 'react';
import PropTypes from 'prop-types';

import ProgressButton from '../_utils/progress-button';
import { builderDispatch, WebUI } from '../_utils/ui';
import { observableEvent } from '../_utils/observable-event';
import { checkoutBlockers, checkoutBlockerById } from './checkout-blockers';
import AnalyticsHandler from '../_libs/analytics/checkout-google-analytics';

const BTN_CLASSES = 'checkout-button btn btn-primary btn-lg btn-block';

class CheckoutButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.checkoutLoginRequested = false;
    this.handleCheckoutLogin = this.handleCheckoutLogin.bind(this);
    this.navigateTo = this.navigateTo.bind(this);
  }

  componentDidMount() {
    this.builderDispatchToken = builderDispatch.register((payload) => {
      switch (payload.type) {
        case WebUI.LOGIN:
          if (this.checkoutLoginRequested) {
            payload.previous_basket_contents || this.navigateTo();
          }
          break;
      }
    });
  }

  componentWillUnmount() {
    builderDispatch.unregister(this.builderDispatchToken);
  }

  handleCheckoutLogin() {
    const showLoginEvent = new Event('showLogin');
    window.dispatchEvent(showLoginEvent);
    this.checkoutLoginRequested = true;
  }

  sendGoogleAnalyticsEvent() {
    const payload = {
      type: WebUI.Analytics.BEGIN_CHECKOUT_EVENT,
    };
    AnalyticsHandler.handleAnalyticsEvent(payload);
  }

  render() {
    const {
      checkoutBlocker,
      text,
      crossSellItemCheckOutClick,
      checkoutDisabled,
      loggedIn,
      checkout,
    } = this.props;
    const btnText = text || 'Check Out';
    const cxoBlockerAttrs = {
      'data-cxo-blocker-id': checkoutBlocker,
      'data-cxo-blocker-text': checkoutBlockerById(checkoutBlocker),
    };

    if (checkoutBlocker === checkoutBlockers.crossSellItem) {
      return (
        <button
          id="cart-btn-cxo-block-xsell"
          {...cxoBlockerAttrs}
          className={BTN_CLASSES}
          onClick={() => {
            this.sendGoogleAnalyticsEvent();
            crossSellItemCheckOutClick();
          }}>
          {btnText}
        </button>
      );
    }

    if (loggedIn || checkout.withoutLogin) {
      if (checkoutDisabled) {
        return (
          <button
            id="cart-btn-cxo-block"
            {...cxoBlockerAttrs}
            className={BTN_CLASSES}
            disabled={checkoutDisabled}>
            {btnText}
          </button>
        );
      }

      return (
        <ProgressButton
          id="cart-btn-cxo"
          data-test-id="checkout-button"
          className={BTN_CLASSES}
          onClick={this.sendGoogleAnalyticsEvent}
          href={checkout.url}
          timeoutMs={60000}
          onTimeout={this.handleProgressButtonTimeout}>
          {btnText}
        </ProgressButton>
      );
    }

    return (
      <button
        id="cart-btn-cxo-login"
        data-test-id="checkout-button"
        {...cxoBlockerAttrs}
        className={BTN_CLASSES}
        onClick={this.handleCheckoutLogin}
        disabled={checkoutDisabled}>
        {btnText}
      </button>
    );
  }

  navigateTo() {
    const url = this.context.checkout.url;
    if (url !== window.location.href) {
      // Don't send analytics if the redirection is back to the cart page
      // The checkout button will handle this onClick
      this.sendGoogleAnalyticsEvent();
    }

    let f = document.createElement('FORM'),
      indexQM,
      params,
      keyValuePair,
      input,
      i;

    f.action = url;
    indexQM = url.indexOf('?');

    if (indexQM > -1) {
      // the URL has parameters => convert them to hidden form inputs
      params = url.substring(indexQM + 1).split('&');
      for (i = 0; i < params.length; i++) {
        keyValuePair = params[i].split('=');
        input = document.createElement('INPUT');
        input.type = 'hidden';
        input.name = keyValuePair[0];
        input.value = keyValuePair[1];
        f.appendChild(input);
      }
    }

    document.body.appendChild(f);
    f.submit();
  }

  handleProgressButtonTimeout(progressButton) {
    observableEvent.record('checkout-button-timeout');
    progressButton.reset();
    alert(
      'There was a problem transferring you to checkout. The failure has been logged. Please try again.',
    );
  }
}

CheckoutButton.propTypes = {
  checkoutBlocker: PropTypes.number,
  text: PropTypes.string,
  crossSellItemCheckOutClick: PropTypes.func,
  checkoutDisabled: PropTypes.bool,
  loggedIn: PropTypes.bool,
  checkout: PropTypes.shape({
    withoutLogin: PropTypes.bool,
    url: PropTypes.string,
  }),
};

CheckoutButton.contextTypes = {
  checkout: PropTypes.shape({
    url: PropTypes.string
  }),
};

export default CheckoutButton;
